module.exports = __webpack_public_path__ + "static/media/modulo-pesquisa.afb1d4c3.svg";